<template>
  <div
    id="ShoppingPromises"
    class="container flex flex-col items-center justify-center gap-1.5 px-2 md:flex-row lg:gap-14"
  >
    <div v-if="!isSwitzerland" class="benefit">
      <span>
        <IconFreeReturnsMobile v-if="isMobile" class="size-6" alt="" />
        <IconFreeReturns v-else class="size-8" alt="" />
      </span>
      {{ $t('benefits.free_returns') }}
    </div>
    <div v-if="!isMobile" class="benefit">
      <span>
        <IconFreeAdvice class="size-8" alt="" />
      </span>
      {{ $t('benefits.free_advice') }}
    </div>
    <div v-if="!isMobile || isSwitzerland" class="benefit">
      <span>
        <IconPaymentProtection class="size-8" alt="" />
      </span>
      {{ $t('benefits.secure_payment') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useDeviceType } from '~/composables/useDeviceType'
import useCountryCheck from '~/composables/useCountryCheck'

export default defineComponent({
  name: 'HeaderBenefits',
  setup() {
    const { isMobile } = useDeviceType()
    const { isInList: isSwitzerland } = useCountryCheck(['fr-ch', 'ch'])

    return {
      isMobile,
      isSwitzerland,
    }
  },
})
</script>
<style lang="postcss" scoped>
.benefit {
  @apply flex flex-row
  justify-start
  items-center
  gap-2
  font-bold
  uppercase
  text-sm;
}
</style>
